import { CommonModule, DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import { UserService } from '@core/services/user.service';
import { RouterModule } from '@angular/router';
import { SearchInputComponent } from '@shared/components/search-input/search-input.component';

@Component({
	selector: 'kwo-mobile-menu',
	templateUrl: './mobile-menu.component.html',
	styleUrls: ['./mobile-menu.component.scss'],
	host: { 'class': '' },
	standalone: true,
	imports: [CommonModule, RouterModule, SearchInputComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileMenuComponent implements OnInit, OnDestroy {

	isLoggedIn: boolean = false;

	constructor(private renderer: Renderer2,
		@Inject(DOCUMENT) private document: Document,
		private userService: UserService) { }

	ngOnInit(): void {

		this.renderer.addClass(this.document.body, 'disable-scroll');

		this.isLoggedIn = this.userService.getUser() !== null;
	}

	ngOnDestroy(): void {

		this.renderer.removeClass(this.document.body, 'disable-scroll');
	}
}
